import "../../assets/css/RightPanel.css";
import "../../../assets/css/templates.css";
import "../../assets/css/AdminTool.css";
import FetchLicense from "../../actions/FetchLicense";
import { useEffect, useRef, useState } from "react";
import {
  Layout,
  Input,
  Divider,
  Spin,
  Modal,
  Tabs,
  Space,
  Table,
  message,
  Badge,
  Card,
  Typography,
  Tag,
  Descriptions,
  Button,
  Select,
  Dropdown,
} from "antd";
import { LinkOutlined, LoadingOutlined, SearchOutlined } from "@ant-design/icons";
import LicenseActions from "../../actions/LicenseActions";
import TableData from "./TableData";
import useAdminHttp from "../../hooks/useAdminHttp";
import { ADMIN_SERVER_API } from "../../AdminConstants";
import AccountActions from "../../actions/AccountActions";
import NoData from "../../pages/NoData";
import ToolsAction from "../../actions/ToolsAction";
import useAuth from "../../hooks/useAuth";
import { checkIsRunningCampaign, getCampaignStatusFromStatusCode } from "../../../pages/campaign/utils/campaignUtils";
import AdminToolUserTab from "./AdminToolUserTab";
import DeleteButton from "./DeleteButton";
import { getDaysDifference } from "../../../pages/utils/CommonVessels";
import DeleteComponent from "../../../pages/utils/components/DeleteComponent";
import AssigneeSelect from "../../../components/common/AssigneeSelect";
export default function CustomersContainer({ parseJsonIntoAntDTable }) {
  const [licenseData, setLicenseData] = useState(null);
  const [licenseStatus, setLicenseStatus] = useState(null);
  const [stripeSubscriptionData, setStripeSubscriptionData] = useState(null);
  const [chargebeeSubscriptionData, setChargebeeSubscriptionData] = useState(null);
  const [userData, setUserData] = useState(null);
  const [accountData, setAccountData] = useState(null);
  const [userFormFields, setUserFormFields] = useState({});
  const [numbersFields, setNumbersFields] = useState({});
  const [authFields, setAuthFields] = useState({});
  const [currentTab, setCurrentTab] = useState();
  const [integrationData, setIntegrationData] = useState([]);
  const [serviceData, setServiceData] = useState([]);
  const [phoneNoData, setPhoneNoData] = useState([]);
  const [authenticationData, setAuthenticationData] = useState([]);
  const [userDataFetched, setUserDataFetched] = useState(false);
  const [authenticationDataFetched, setAuthenticationDataFetched] = useState(false);
  const [phoneDataFetched, setPhoneDataFetched] = useState(false);
  const [searchWord, setSearchWord] = useState();
  const [licenseInfoNotifiers, setLicenseInfoNotifiers] = useState();
  const [customerInfoItems, setCustomerInfoItems] = useState([]);
  const [allCRMData, setAllCRMData] = useState();
  const [itemSelectorModalVisible, setItemSelectorModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [cancelMessagePlusCallLoading, setCancelMessagePlusCallLoading] = useState(false);
  const [listOfItems, setListOfItems] = useState();
  const [filterCampaign, setFilterCampaign] = useState("");
  const [campaignData, setCampaignData] = useState();
  const [campaignTableData, setCampaignTableData] = useState();
  const [userDeleteMigrationModal, setUserDeleteMigrationModal] = useState({
      open: false,
      source: null,
      conversationCount: 0,
      contactsCount: 0,
      requiresMigration: false,
      submitting: false,
      loading: true,
      target: null,
      eligibleMigrationUsers: [],
  });
  const newOsyncIdCallRef = useRef();
  const accountOwnerDataRef = useRef();
  const licenseStatusEnumRef = useRef(null);
  const [fetchDataDbOrZoho, setFetchDataDbOrZoho] = useState("1");

  const { fetchData } = useAdminHttp();
  const { Text } = Typography;
  const { customerResData, setCustomerResData, zohoCRMData, setZohoCRMData } = useAuth();
  const isProductionSetup = ADMIN_SERVER_API?.indexOf("oapps.xyz") !== -1;

  message.config({
    maxCount: 3,
    top: 50,
  });

  var licenseInfoNotifiersMap = new Map([
    ["basic", "grey"],
    ["gold", "gold"],
    ["silver", "silver"],
    ["unlimited", "magenta"],
    ["free", "white"],
    ["chatgpt", "gainsboro"],
    ["premium", "rosegold"],
  ]);

  var licenseTypeAndTagColorMap = new Map([
    [1, { licenseType: "ACTIVE", tagColor: "green" }],
    [2, { licenseType: "TRIAL", tagColor: "yellow" }],
    [3, { licenseType: "FREE", tagColor: "orange" }],
    [4, { licenseType: "TRIAL", tagColor: "yellow" }],
    [5, { licenseType: "TRIAL", tagColor: "yellow" }],
    [6, { licenseType: "TRIAL", tagColor: "yellow" }],
    [11, { licenseType: "TRIAL ENDED", tagColor: "grey" }],
    [21, { licenseType: "INACTIVE", tagColor: "red" }],
    [22, { licenseType: "INACTIVE", tagColor: "red" }],
    [23, { licenseType: "PAUSED", tagColor: "bisque" }],
    [24, { licenseType: "TRIAL ENDED", tagColor: "grey" }],
    [30, { licenseType: "INACTIVE", tagColor: "red" }],
  ]);

  useEffect(() => {
    if (zohoCRMData) {
      fetchCustomerData(zohoCRMData);
    }
  }, [zohoCRMData]);

  useEffect(() => {
    if (accountData) {
      fetchLicenseData();
      fetchUserData();
    }
  }, [accountData]);

  useEffect(() => {
    if (accountData && !filterCampaign) {
      fetchCampaigns();
    }
  }, [accountData, filterCampaign]);

  useEffect(() => {
    if (campaignData?.length > 0 && filterCampaign) {
      const filteredResult = campaignData.filter((obj) => Object.values(obj).some((value) => value?.toString().includes(filterCampaign)));
      setCampaignTableData(filteredResult);
    } else {
      setCampaignTableData(campaignData);
    }
  }, [campaignData, filterCampaign]);

  useEffect(() => {
    const descriptionItems = document.querySelectorAll(".ant-descriptions-item-content");
    descriptionItems.forEach((item) => {
      item.addEventListener("dblclick", copyHandler);
    });
    function copyHandler(event) {
      navigator.clipboard.writeText(event.currentTarget.textContent);
      message.success("Copied to clipboard");
    }
    return () => {
      descriptionItems.forEach((item) => {
        item.removeEventListener("dblclick", copyHandler);
      });
    };
  }, [customerInfoItems]);

  useEffect(() => {
    if (userData) {
      accountOwnerDataRef.current = userData.find((user) => user?.roleId === 11);
    }
  }, [userData]);

  const getDomainFromPlanName = (data) => {
    let domain = data?.split("_")?.[2]?.replace(/^http(s?):\/\//i, "");
    return domain;
  };

  useEffect(() => {
    try {
      if (customerResData) {
        let trialStartDate = customerResData?.omni?.trialStartDate;
        let createdTime = customerResData?.omni?.createdTime;
        let createdDate = new Date(trialStartDate || createdTime);
        let trialDays = customerResData?.omni?.trialDays || 3;
        let trialEndDate = new Date(createdDate.getTime() + trialDays * 24 * 60 * 60 * 1000);
        let trialDaysLeft = getDaysDifference(trialEndDate, new Date());
        licenseStatusEnumRef.current = customerResData?.licenseStatusEnum;

        let accData = clubAccountIntegAndService(customerResData?.account, customerResData?.integrations, customerResData?.service);
        if (accData === null) {
          setAccountData(null);
          throw new Error("No Account/Integration data found in our table!");
        }

        setCustomerInfoItems([
          {
            key: 0,
            label: "Name",
            children: zohoCRMData["Full_Name"] === undefined ? "-" : zohoCRMData["Full_Name"],
          },
          {
            key: 1,
            label: "Email",
            children: accData["Email"],
          },
          {
            key: 2,
            label: "Domain",
            children: getDomainFromPlanName(customerResData?.account.planName),
          },
          {
            key: 4,
            label: "Left Service",
            children: accData["Left Service Name"]?.toUpperCase(),
          },
          {
            key: 3,
            label: "Integration ID",
            children: accData["Integ ID"],
          },
          {
            key: 5,
            label: "Right Service",
            children: accData["Right Service Name"]?.toUpperCase(),
          },
          {
            key: 6,
            label: "Osync ID",
            children: accData["Osync ID"],
          },
          {
            key: 6,
            label: "New Osync ID",
            children: accData["zcrmMigratedNewOsyncId"],
          },
          {
            key: 7,
            label: "Trial Days Left",
            children:
              customerResData?.omni?.licenseStatus === licenseStatusEnumRef.current?.TRIAL_EXTENDED
                ? trialDaysLeft > 0
                  ? trialDaysLeft
                  : 0
                : 0,
          },
        ]);
        if (customerResData?.omni) {
          checkAndSetLicenseType(customerResData?.omni);
        } else {
          setLicenseInfoNotifiers(null);
          setLicenseData(null);
          message.warning("No Omni License data found.");
        }
        setAccountData(accData);
        setIntegrationData(customerResData?.integrations);
        setServiceData(customerResData?.service);
        getFields("user");
        getFields("number");
        getFields("authentication");
        setLicenseData(customerResData?.omni);
      }
    } catch (error) {
      setAccountData(null);
      setLicenseData(null);
      console.error("Error:", error.message);
      message.error(error.message);
    } finally {
      setLoading(false);
    }
  }, [customerResData]);

  const fetchCustomerData = (currentData) => {
    setLoading(true);
    fetchData("customer?osyncId=" + currentData?.osyncId, "get", null)
      .then((res) => {
        if (res?.status === 200 && res?.data) {
          setCustomerResData(res?.data);
        } else {
          throw new Error("No data found !");
        }
      })
      .catch((err) => {
        setAccountData(null);
        setLicenseData(null);
        message.error(err.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const leftServiceName = accountData && accountData["Left Service Name"]?.toLowerCase()?.replace(/[-_\s]/g, "");
  const rightServiceName = accountData && accountData["Right Service Name"]?.toLowerCase()?.replace(/[-_\s]/g, "");
  const serviceMap = new Map([["zohocrm_ringcentral", "stripe"]]);
  const concatenatedServiceName = leftServiceName + "_" + rightServiceName;

  const fetchLicenseData = () => {
    if (serviceMap.get(concatenatedServiceName) === "stripe") {
      fetchData(
        "stripe/customer?osyncId=" +
          accountData["Osync ID"] +
          "&leftServiceId=" +
          accountData["Left Service ID"] +
          "&rightServiceId=" +
          accountData["Right Service ID"],
        "get",
        null,
      )
        .then((res) => {
          try {
            if (res?.status === 200 && res?.data) {
              setLicenseStatus(res?.data?.subscription?.status);
              setStripeSubscriptionData(res?.data);
              setChargebeeSubscriptionData(null);
            } else {
              setLicenseStatus(null);
              setStripeSubscriptionData(null);
              setChargebeeSubscriptionData(null);
              message.warning("No Subscription Data Found");
            }
          } catch (error) {
            console.error("Error processing subscription data:", error);
            message.error("Error occurred while processing subscription data");
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
          message.error("An error occurred while fetching data.");
        });
    } else {
      var osyncId = customerResData?.account?.osyncId;
      if (accountData?.zcrmMigratedNewOsyncId) {
        osyncId = customerResData?.account?.zcrmMigratedNewOsyncId;
      }

      fetchData("chargebee/customer?osyncId=" + osyncId, "get", null)
        .then((res) => {
          try {
            if (res?.status === 200 && res?.data) {
              setChargebeeSubscriptionData(res?.data);
              setStripeSubscriptionData(null);
              setLicenseStatus(res?.data?.subscription?.subscription?.status);
            } else {
              setLicenseStatus(null);
              setChargebeeSubscriptionData(null);
              setStripeSubscriptionData(null);

              message.warning("No Subscription Data Found!");
            }
          } catch (error) {
            console.error("Error processing subscription data:", error);
            message.error("An error occurred while processing subscription data");
          }
        })
        .catch((error) => {
          console.error("Error fetching subscription data:", error);
          message.error("Failed to fetch subscription data.");
        });
    }
  };
  const checkAndSetLicenseType = (data) => {
    var tempTypeAndTag = licenseTypeAndTagColorMap.get(data.licenseStatus);
    var tempLicenseNotifier = {
      licensePlanName: data.licensePlanName,
      ribbonColour: licenseInfoNotifiersMap.get(data?.licensePlanName?.toLowerCase()),
      licenseType: tempTypeAndTag.licenseType,
      tagColor: tempTypeAndTag.tagColor,
    };
    setLicenseInfoNotifiers(tempLicenseNotifier);
  };

  const clubAccountIntegAndService = (accData, integData, servData) => {
    let clubbedAccountData;
    if (accData) {
      if (accData?.zcrmMigratedNewOsyncId) {
        setSearchWord(accData?.zcrmMigratedNewOsyncId);
        searchHandler(accData?.zcrmMigratedNewOsyncId);
      }
      let leftServiceName = null;
      let rightServiceName = null;
      if (!integData) {
        message.warning("No integration found");
        integData = {
          leftServiceId: null,
          rightServiceId: null,
          integId: null,
        };
      } else {
        servData.forEach((ele) => {
          if (ele?.serviceId === integData[0]?.leftServiceId) {
            leftServiceName = ele?.displayName;
          }
        });
        servData.forEach((ele) => {
          if (ele?.serviceId === integData[0]?.rightServiceId) {
            rightServiceName = ele?.displayName;
          }
        });
      }

      clubbedAccountData = {
        "Left Service ID": integData.length > 0 ? integData[0].leftServiceId : integData.leftServiceId,
        "Right Service ID": integData.length > 0 ? integData[0].rightServiceId : integData.rightServiceId,
        "Remote Identifier": accData.remoteIdentifier,
        "Channel Type": accData.accountType,
        Inbox: accData.isInboxEnabled,
        "Left Service Name": leftServiceName,
        "Right Service Name": rightServiceName,
        "Created Time": accData.createdTime,
        "Integ ID": integData.length > 0 ? integData[0].integId : integData.integId,
        "Osync ID": accData?.osyncId,
        Email: accData.email,
        "Subscription Start": zohoCRMData["Subscription_Start"] ? zohoCRMData["Subscription_Start"] : "-",
        "Subscription Update": zohoCRMData["Subscription_Update"] ? zohoCRMData["Subscription_Update"] : "-",
        zcrmMigratedNewOsyncId: accData?.zcrmMigratedNewOsyncId,
      };
    } else {
      return null;
    }
    return clubbedAccountData;
  };

  const columns = [
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "OsyncId",
      dataIndex: "osyncId",
      key: "osyncId",
    },
  ];

  const searchHandler = (osyncId) => {
    if (loading) return;
    let searchItem = searchWord;
    if (osyncId && typeof osyncId === "string") searchItem = osyncId;
    if (fetchDataDbOrZoho !== "2") {
      setLoading(true);
      fetchData("search?searchWord=" + searchItem, "get", null)
        .then((res) => {
        if (res?.status === 200 && res?.data) {
          const searchData = res.data.data || [res.data];
          handleSearchFromZohoSearch(searchData);
          setCurrentTab("license");
          setPhoneNoData([]);
          setUserData([]);
          setIntegrationData([]);
          setServiceData([]);
          setAuthenticationData([]);
          setAuthenticationDataFetched(false);
          setUserDataFetched(false);
          setPhoneDataFetched(false);
        } else if (res?.status === 403) {
          throw new Error("Something wrong happened");
        } else if (res?.status === 200) {
          throw new Error("No response from Zoho CRM.");
        }
      })
        .catch((err) => {
          message.error(err.message);
          setLicenseData(null);
          setAccountData(null);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setZohoCRMData({ osyncId: searchWord });
    }
  };

  const handleCurrentTab = (key) => {
    setCurrentTab(key);
    if (key === "numbers" && !phoneDataFetched) {
      if (accountData["Osync ID"] !== null && integrationData?.length > 0 && serviceData?.length > 0) {
        integrationData.forEach((integration) => {
          serviceData.forEach((service) => {
            if (integration?.rightServiceId === service?.serviceId) {
              fetchPhoneData(accountData["Osync ID"], integration?.integId);
            }
          });
        });
        setPhoneDataFetched(true);
      }
    } else if (key === "authentications" && !authenticationDataFetched) {
      if (accountData["Osync ID"]) {
        fetchCustomerAuthData(accountData["Osync ID"]);
        setAuthenticationDataFetched(true);
      }
    }
  };

  const getFields = (className) => {
    try {
      if (className) {
        fetchData(`${className}/schema`, "get", null).then((res) => {
          if (res?.status === 200 && res?.data) {
            if (className === "user") {
              setUserFormFields(res?.data);
            } else if (className === "authentication") {
              setAuthFields(res?.data);
            } else if (className === "number") {
              setNumbersFields(res?.data);
            }
          }
        });
      }
    } catch (error) {
      message.error(error.message);
    }
  };
  const fetchUserData = () => {
    setLoading(true);
    if (accountData) {
      var osyncId = accountData["Osync ID"];
      if (accountData?.zcrmMigratedNewOsyncId) {
        osyncId = accountData?.zcrmMigratedNewOsyncId;
      }
      fetchData("customer/users?osyncId=" + osyncId, "get", null)
        .then((res) => {
          try {
            if (res?.status === 200 && res?.data.length > 0) {
              setUserDataFetched(true);
              setUserData(res?.data);
            } else if (res.status === 200 && res?.data.length <= 0) {
              message.error("There is no user");
            }
          } catch (error) {
            console.error("Error fetching Data:", error);
          }
        })
        .catch((error) => {
          message.error(error.message);
          setUserData(null);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };
  const fetchCampaigns = () => {
    if (accountData) {
      var osyncId = accountData["Osync ID"];
      if (accountData?.zcrmMigratedNewOsyncId) {
        osyncId = accountData?.zcrmMigratedNewOsyncId;
      }
      let targetUrl = "customer/campaigns?osyncId=" + osyncId;
      if (filterCampaign) {
        targetUrl += "&campaignId=" + filterCampaign;
      }
      fetchData(targetUrl, "get", null)
        .then((res) => {
          try {
            if (res?.status === 200 && res?.data?.length > 0) {
              setCampaignData(res?.data);
            } else {
              setCampaignData();
            }
          } catch (error) {
            console.error("err  ", error);
          }
        })
        .catch((error) => {})
        .finally(() => {});
    }
  };
  const fetchPhoneData = (osyncId, integId) => {
    setLoading(true);
    if (osyncId && integId) {
      fetchData("customer/numbers?osyncId=" + osyncId, "get", null)
        .then((res) => {
          if (res?.status === 200 && res?.data) {
            setPhoneNoData((prevData) => [...prevData, ...res?.data]);
          }
        })
        .catch((error) => {
          message.error(error.message);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const fetchCustomerAuthData = (osyncId) => {
    setLoading(true);
    if (osyncId) {
      fetchData("customer/authentications?osyncId=" + osyncId, "get", null)
        .then((res) => {
          if (res?.status === 200 && res?.data) {
            setAuthenticationData(res?.data);
          } else if (res?.status === 200 && res.data.length < 1) {
            setAuthenticationData([]);
          }
        })
        .catch((error) => {
          message.error(error.message);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const handleDeleteUserClick = async (record) => {
      if (!record?.osyncUserId || !accountData) return;
      const osyncId = accountData?.zcrmMigratedNewOsyncId || accountData["Osync ID"];
      const leftServiceId = accountData["Left Service ID"];
      setUserDeleteMigrationModal({
          open: true,
          source: record,
          loading: true,
          requiresMigration: false,
          target: null,
          eligibleMigrationUsers: [],
      });
      try {
          const params = new URLSearchParams({
              osyncUserId: record.osyncUserId,
              osyncId,
          });
          if (leftServiceId) params.append("leftServiceId", leftServiceId);
          const res = await fetchData(`customer/user/delete-preview?${params.toString()}`, "get", null);
          if (res?.status === 200 && res?.data) {
              setUserDeleteMigrationModal((prev) => ({
                  ...prev,
                  ...res.data,
                  loading: false,
              }));
          } else {
              setUserDeleteMigrationModal((prev) => ({ ...prev, requiresMigration: true, loading: false }));
          }
      } catch (err) {
          setUserDeleteMigrationModal((prev) => ({ ...prev, requiresMigration: true, loading: false }));
      }
  };

  const handleAdminMigrationConfirm = async () => {
      const { source, target, requiresMigration } = userDeleteMigrationModal;
      if (!source) {
          setUserDeleteMigrationModal((prev) => ({ ...prev, open: false }));
          return;
      }
      if (requiresMigration && !target) {
          message.warning("Please select a user to reassign conversations to.");
          return;
      }
      setUserDeleteMigrationModal((prev) => ({ ...prev, submitting: true }));
      const osyncId = accountData?.zcrmMigratedNewOsyncId || accountData["Osync ID"];
      const leftServiceId = accountData["Left Service ID"];
      const payload = {
          leftServiceId,
          osyncUserId: source.osyncUserId,
      };
      if (requiresMigration && target) {
          payload.migrationEntityId = target;
          const isUser = userData?.some((u) => u.osyncUserId === target);
          payload.migrationEntityType = isUser ? "user" : "team";
      }
      try {
          const body = requiresMigration && target ? JSON.stringify(payload) : null;
          const res = await fetchData(`customer/user/${source.osyncUserId}?osyncId=${osyncId}`, "delete", body);
          if (res?.status === 200 && res?.data) {
              const newUser = userData.filter((u) => u.osyncUserId !== source.osyncUserId);
              setUserData(newUser);
              message.success("User removed successfully.");
          } else {
              message.error(res?.data?.message || "Failed to delete user.");
          }
      } catch (err) {
          message.error(err?.message || "Failed to delete user.");
      } finally {
          setUserDeleteMigrationModal((prev) => ({ ...prev, submitting: false, open: false }));
      }
  };

  const handleDelete = (record, tab, closeDeleteModal = () => {}) => {
    try {
      if (tab === "user") {
        const { osyncUserId, osyncId } = record;
        if (osyncUserId && osyncId) {
          fetchData(`customer/user/${osyncUserId}?osyncId=` + osyncId, "delete", null)
            .then((res) => {
              if (res?.status === 200 && res?.data) {
                const newUser = userData.filter((items) => items.osyncUserId !== osyncUserId);
                setUserData(newUser);
              }
            })
            .catch((error) => {
              message.error(error.message);
            });
        }
      } else if (tab === "number") {
        const { osyncId_integId, phoneNumber } = record;
        const integId = osyncId_integId?.split("_")[1];
        if (integId && phoneNumber && accountData["Osync ID"]) {
          fetchData(`customer/number/${phoneNumber}?osyncId=` + accountData["Osync ID"] + "&integId=" + integId, "delete", null)
            .then((res) => {
              if (res?.status === 200 && res?.data) {
                const newPhoneNumbers = phoneNoData.filter((items) => items.phoneNumber !== phoneNumber);
                setPhoneNoData(newPhoneNumbers);
              }
            })
            .catch((error) => {
              message.error(error.message);
            });
        }
      } else if (tab === "authentication") {
        if (accountData["Osync ID"]) {
          const data = Object?.fromEntries(Object?.entries(record)?.filter(([key, value]) => key !== "key"));
          const payload = JSON.stringify(data);
          fetchData("customer/authentication?osyncId=" + accountData["Osync ID"], "delete", payload)
            .then((res) => {
              if (res?.status === 200 && res?.data) {
                const newAuthData = authenticationData.filter(
                  (items) => items.osyncId_serviceId !== record.osyncId_serviceId && items.osyncId_integId !== record.osyncId_integId,
                );
                setAuthenticationData(newAuthData);
              }
            })
            .catch((error) => {
              message.error(error.message);
            });
        }
      } else if (tab === "campaign") {
        const { campaignId, osyncId } = record;
        if (campaignId && osyncId) {
          fetchData(`customer/campaign/${campaignId}?osyncId=` + osyncId, "PUT", null)
            .then((res) => {
              if (res?.status === 200 && res?.data) {
                const updatedCampaignData = campaignData.map((item) => (item.campaignId === campaignId ? { ...item, ...res?.data } : item));
                setCampaignData(updatedCampaignData);
              }
            })
            .catch((error) => {
              message.error(error.message);
            });
        }
      }
    } catch (error) {
      message.error(error.message);
    } finally {
      closeDeleteModal();
    }
  };

  const tableDataColumns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Value",
      dataIndex: "value",
      key: "value",
    },
  ];

  const integrationColumns = [
    {
      title: "LeftServiceName",
      dataIndex: "leftServiceName",
      key: "leftServiceName",
    },
    {
      title: "LeftServiceId",
      dataIndex: "leftServiceId",
      key: "leftServiceId",
    },
    {
      title: "RightServiceId",
      dataIndex: "rightServiceId",
      key: "rightServiceId",
    },
    {
      title: "rightServiceName",
      dataIndex: "rightServiceName",
      key: "rightServiceName",
    },
  ];
  const campaignColumns = [
    {
      title: "CampaignId",
      dataIndex: "campaignId",
      key: "campaignId",
    },
    {
      title: "Status",
      dataIndex: "campaignStatus",
      key: "campaignStatus",
      render: (data) => getCampaignStatusFromStatusCode(data)?.toUpperCase(),
    },
    {
      title: "Scheduled",
      dataIndex: "scheduledCampaign",
      key: "scheduledCampaign",
    },
    {
      title: "Campaign Name",
      dataIndex: "campaignName",
      key: "campaignName",
    },
    {
      title: "integId",
      dataIndex: "integId",
      key: "integId",
    },
  ];
  const userColumns = Object.keys(userFormFields)
    ?.filter((column) => column !== "osyncId" && column !== "shardId" && column !== "adminUser")
    ?.map((column) => {
      return {
        title: column.charAt(0).toUpperCase() + column.slice(1),
        dataIndex: column,
        key: column,
      };
    });

  const authenticationsColumns = Object?.keys(authFields)
    ?.filter((column) => column !== "accessToken" && column !== "refreshToken" && column !== "securityContext")
    ?.map((column) => ({
      title: column.charAt(0).toUpperCase() + column.slice(1),
      dataIndex: column,
      key: column,
      width: 200,
    }));
  const numbersColumns = Object?.keys(numbersFields)?.map((column) => ({
    title: column.charAt(0).toUpperCase() + column.slice(1),
    dataIndex: column,
    key: column,
    width: 200,
  }));

  const columnWithDelete = (
      columnsData,
      handleDelete,
      dataType,
      data,
      Delete,
      prefixColumnObject = [],
      MakeAccountOwnerButtonComponent = null,
      makeAccountOwnerButtonProps = {},
      shouldShowDeleteButton = () => true,
      forUserDeleteHandler = null
  ) => {
      const columns = columnsData.map((column) => ({
          title: column.title,
          dataIndex: column.dataIndex,
          key: column.key,
          render: column?.render,
      }));

      const filteredColumns = [
          ...prefixColumnObject,
          ...columns.filter((column) =>
              data?.some(
                  (item) =>
                      item[column.dataIndex] !== null &&
                      item[column.dataIndex] !== undefined &&
                      item[column.dataIndex] !== ""
              )
          ),
          {
              title: "Role",
              dataIndex: "role",
              key: "role",
              render: (_, record) => {
                  if (record?.roleId === 11) {
                      return "ACCOUNT OWNER";
                  }
                  return (
                      customerResData?.roles?.find((role) => role?.roleId === record?.roleId)?.roleName ||
                      record?.roleId
                  );
              },
          },
          {
              title: "",
              dataIndex: "Action",
              key: "Action",
              fixed: "right",
              render: (_, record) => {
                  const menuItems = [];
                  if (dataType === "user" && MakeAccountOwnerButtonComponent && record?.roleId !== 11) {
                      menuItems.push({
                          key: "makeAccountOwner",
                          label: <MakeAccountOwnerButtonComponent record={record} {...makeAccountOwnerButtonProps} />,
                      });
                  }
                  const deleteDisabled = dataType === "user" && data?.length <= 1;
                  const shouldShowDelete = shouldShowDeleteButton(record);

                  if (shouldShowDelete && !deleteDisabled) {
                      menuItems.push({
                          key: "delete",
                          label: (
                              <DeleteButton
                                  dataType={dataType}
                                  Delete={Delete}
                                  record={record}
                                  handleDelete={handleDelete}
                                  onCustomDeleteClick={
                                      dataType === "user" && forUserDeleteHandler ? forUserDeleteHandler : undefined
                                  }
                              />
                          ),
                          disabled: deleteDisabled,
                      });
                  }

                  return (
                      menuItems.length > 0 && (
                          <Dropdown menu={{ items: menuItems }} trigger={["click"]} placement="bottomRight">
                              <div className="actionIconsSprite  editDeleteSettingsIcon cursor-pointer"></div>
                          </Dropdown>
                      )
                  );
              },
          },
      ];

      return filteredColumns;
  };
  let integrationTabData = [];
  const addServiceNamesToIds = (integrations, services) => {
    return integrations?.map((integration) => {
      const { leftServiceId, rightServiceId } = integration;
      const leftService = services?.find((service) => service.serviceId === leftServiceId);
      const rightService = services?.find((service) => service.serviceId === rightServiceId);
      return {
        ...integration,
        leftServiceName: leftService ? leftService.name : null,
        rightServiceName: rightService ? rightService.name : null,
      };
    });
  };

  if (integrationData && customerResData?.service) {
    integrationTabData = addServiceNamesToIds(integrationData, customerResData?.service);
  }

  const excludedFields = [
    "osyncId",
    "shardId",
    "adminUser",
    "zcrmMigrationTag",
    "phone",
    "adminUser",
    "firstName",
    "avatar",
    "osyncUserId",
    "timeZone",
    "lastName",
    "country",
    "fullName",
  ];
  const filteredUserFormFields = Object.keys(userFormFields)
    .filter((field) => !excludedFields.includes(field))
    .reduce((obj, key) => {
      obj[key] = userFormFields[key];
      return obj;
    }, {});

  const handleCancelMessagePlusCall = () => {
    setCancelMessagePlusCallLoading(true);
    if (customerResData?.omni) {
      if (customerResData?.omni?.planToUpdate && customerResData?.omni?.planToUpdate.includes("Voice-plus-Messaging")) {
        const osyncId = customerResData?.omni?.osyncId;
        const licenseIdentifier = customerResData?.omni?.licenseIdentifier;

        const params = new URLSearchParams();
        if (osyncId) params.append("osyncId", osyncId);
        if (licenseIdentifier) params.append("licenseIdentifier", licenseIdentifier);
        params.append("activate", "");
        params.append("actionType", "cancelMessagePlusCall");

        fetchData(`license/subscription?${params.toString()}`, "PUT", null)
          .then((res) => {
            if (res?.status === 200 && res?.data) {
              message.success("Message Plus Call removed successfully");
            }
          })
          .catch((error) => {
            message.error(error.message);
          })
          .finally(() => {
            setCancelMessagePlusCallLoading(false);
          });
      }
    }
  };

  const customerTabItems = [
      {
          label: "License",
          key: "license",
          children: (
              <Space className="w-100" direction="vertical">
                  <>
                      <Space className="w-100" direction="horizontal">
                          <LicenseActions fetchCustomerData={fetchCustomerData} licenseData={licenseData} />
                          <FetchLicense
                              accountData={accountData}
                              status={licenseStatus}
                              stripeSubscriptionData={stripeSubscriptionData}
                              chargebeeSubscriptionData={chargebeeSubscriptionData}
                          />
                          {customerResData?.omni?.planToUpdate &&
                              customerResData?.omni?.planToUpdate.includes("Voice-plus-Messaging") && (
                                  <Button
                                      danger
                                      buttonClassName="hs-fw-600 w-100"
                                      onClick={handleCancelMessagePlusCall}
                                      loading={cancelMessagePlusCallLoading}
                                  >
                                      Cancel Message Plus Call trial
                                  </Button>
                              )}
                      </Space>
                      <TableData customersData={licenseData} columns={tableDataColumns} rowWise={true} />
                  </>
              </Space>
          ),
      },
      {
          label: "Account",
          key: "account",
          children: (
              <Space className="w-100" direction="vertical">
                  <AccountActions fetchCustomerData={fetchCustomerData} accountData={accountData} />
                  <TableData customersData={accountData} columns={tableDataColumns} rowWise={true} />
              </Space>
          ),
      },
      {
          label: "Tools",
          key: "tools",
          id: "tools",
          children: <ToolsAction userData={userData} />,
      },
      {
          label: "Integrations",
          key: "integrations",
          children: <TableData customersData={integrationTabData} columns={integrationColumns} rowWise={false} />,
      },
      {
          label: "Campaigns",
          key: "campaigns",
          children: (
              <Space direction="vertical" className="w-100">
                  <Input
                      value={filterCampaign}
                      onChange={(e) => {
                          setFilterCampaign(e.target.value);
                      }}
                      placeholder="Search or filter Campaigns"
                      onKeyDown={(e) => {
                          if (e.key === "Enter" && !e.shiftKey) {
                              e.preventDefault();
                              fetchCampaigns();
                          }
                      }}
                  />
                  <TableData
                      customersData={campaignTableData}
                      columns={columnWithDelete(
                          campaignColumns,
                          handleDelete,
                          "campaign",
                          campaignTableData,
                          "Stop",
                          [],
                          null,
                          null,
                          (record) => {
                              return !(record?.campaignStatus && !checkIsRunningCampaign(record?.campaignStatus));
                          }
                      )}
                      rowWise={false}
                  />
              </Space>
          ),
      },
      {
          label: "User",
          key: "user",
          children: (
              <AdminToolUserTab
                  userData={userData}
                  userColumns={userColumns}
                  columnWithDelete={columnWithDelete}
                  handleDelete={handleDelete}
                  accountData={accountData}
                  customerResData={customerResData}
                  setCustomerResData={setCustomerResData}
                  accountOwnerDataRef={accountOwnerDataRef}
                  fetchUserData={fetchUserData}
                  userFormFields={userFormFields}
                  forUserDeleteHandler={handleDeleteUserClick}
              />
          ),
      },
      {
          label: "Numbers",
          key: "numbers",
          children: (
              <Space className="w-100" direction="vertical">
                  <TableData
                      customersData={phoneNoData}
                      columns={columnWithDelete(numbersColumns, handleDelete, "number", phoneNoData, "Delete")}
                      rowWise={false}
                  />
              </Space>
          ),
      },
      {
          label: "Authentications",
          key: "authentications",
          children: (
              <Space className="w-100" direction="vertical">
                  <TableData
                      customersData={authenticationData}
                      columns={columnWithDelete(
                          authenticationsColumns,
                          handleDelete,
                          "authentication",
                          authenticationData,
                          "Delete"
                      )}
                      rowWise={false}
                  />
              </Space>
          ),
      },
      {
          label: (
              <>
                  {licenseInfoNotifiers ? (
                      <Tag color={licenseInfoNotifiers.tagColor}>{licenseInfoNotifiers.licenseType}</Tag>
                  ) : (
                      <></>
                  )}
              </>
          ),
          key: "licenseType",
          disabled: true,
      },
  ];

  const handleSearchFromZohoSearch = (data) => {
    if (data && data.length > 0) {
      if (data.length > 1) {
        setAllCRMData(data);
        var temp = [];
        data.forEach((item) => {
          var subTemp = {
            osyncId: item.OsyncId,
            email: item.Email,
          };
          temp.push(subTemp);
        });
        setListOfItems(parseJsonIntoAntDTable(temp, false));
        setItemSelectorModalVisible(true);
      } else {
        const currentData = data[0];
        if (currentData.OsyncId && isProductionSetup) {
          currentData["osyncId"] = currentData["OsyncId"];
        }
        setZohoCRMData(currentData);
      }
    }
  };

  const searchInputChangeHandler = (e) => {
    setSearchWord(e.currentTarget.value);
  };

  const antIcon = <LoadingOutlined style={{ color: "blueviolet", fontSize: 40 }} spin />;

  const handleRowClick = (record) => {
    const currentCustomerCRMData = allCRMData.find((ele) => ele["OsyncId"] === record.osyncId);
    if (currentCustomerCRMData.OsyncId && isProductionSetup) {
      currentCustomerCRMData["osyncId"] = currentCustomerCRMData["OsyncId"];
    }
    setZohoCRMData(currentCustomerCRMData);
    setItemSelectorModalVisible(false);
  };
  const handleChange = (value) => {
    setFetchDataDbOrZoho(value);
  };

  const resetUserDeleteMigrationModal = () =>
      setUserDeleteMigrationModal({
          open: false,
          source: null,
          conversationCount: 0,
          contactsCount: 0,
          requiresMigration: false,
          submitting: false,
          loading: false,
          target: null,
          eligibleMigrationUsers: [],
      });

  return (
      <>
          <DeleteComponent
              modalOpen={userDeleteMigrationModal.open}
              setModalOpen={(open) => !open && resetUserDeleteMigrationModal()}
              record={userDeleteMigrationModal.source}
              confirmDeleteIcon="hs-delete-icon-normal"
              confirmDeleteBtnName={userDeleteMigrationModal.requiresMigration ? "Reassign & Delete" : "Delete"}
              confirmDeleteComponentTitle="Delete User"
              confirmDeleteComponent={
                  userDeleteMigrationModal.requiresMigration ? (
                      <div>
                          <p className="m-0 hs-color-light-grey-2">
                              Are you sure you want to delete this user? This action cannot be undone.
                          </p>
                          <p className="pb-2 py-3 m-0 hs-fs-12 hs-color-dark-grey hs-fw-500">
                              Reassign conversations to
                          </p>
                          <AssigneeSelect
                              value={userDeleteMigrationModal.target}
                              onChange={(val) => setUserDeleteMigrationModal((prev) => ({ ...prev, target: val }))}
                              placeholder="Select target user"
                              usersList={userDeleteMigrationModal.eligibleMigrationUsers}
                              teamsList={[]}
                              excludeUserIds={
                                  userDeleteMigrationModal.source ? [userDeleteMigrationModal.source.osyncUserId] : []
                              }
                              disabled={userDeleteMigrationModal.submitting}
                              groupBy={null}
                          />
                          <p className="m-0 hs-color-light-grey-2 hs-fs-12">
                              Active conversations will be transferred to the selected user
                          </p>
                      </div>
                  ) : (
                      <p className="m-0 hs-color-light-grey-2 hs-fw-400">
                          Are you sure you want to delete this user? This action cannot be undone.
                      </p>
                  )
              }
              showLoadingOnly={userDeleteMigrationModal.loading}
              confirmDisabled={userDeleteMigrationModal.requiresMigration && !userDeleteMigrationModal.target}
              handleDelete={handleAdminMigrationConfirm}
          />
          {listOfItems ? (
              <Modal
                  style={{ minWidth: "70%" }}
                  open={itemSelectorModalVisible}
                  title="Customers"
                  maskClosable={false}
                  onOk={null}
                  footer={null}
                  onCancel={() => setItemSelectorModalVisible(false)}
              >
                  <Table
                      className="mt-4"
                      scroll={{ y: 400 }}
                      pagination={false}
                      dataSource={listOfItems}
                      columns={columns}
                      onRow={(record) => ({
                          onClick: () => handleRowClick(record),
                      })}
                  />
              </Modal>
          ) : (
              <></>
          )}

          <Layout className="ms-5">
              <div className="row w-100 mt-3">
                  <div className="col-24">
                      <div className="row d-flex searchBar">
                          <div className="col-4">
                              <Select
                                  suffixIcon={<div className="actionIconsSprite fromNumberDropDownIcon" />}
                                  className="selectModule focus-border rounded hs-bg-off-white"
                                  // defaultValue="Private"
                                  onChange={handleChange}
                                  value={fetchDataDbOrZoho}
                                  variant="borderless"
                                  style={{ width: "14rem", fontSize: "16px", height: "2.5rem" }}
                                  options={[
                                      {
                                          value: "2",
                                          label: "FetchData From DB",
                                      },
                                      {
                                          value: "1",
                                          label: "FetchData From Zoho CRM",
                                      },
                                  ]}
                              />
                          </div>
                          <div className="col-5">
                              <Input
                                  data-cy="customerSearchBar"
                                  onPressEnter={() => {
                                      searchHandler();
                                  }}
                                  value={searchWord}
                                  variant="borderless"
                                  onChange={searchInputChangeHandler}
                                  placeholder="Enter Osync Id / Email / Domain / Remote Identifier"
                              />
                          </div>
                          <div className="col-1">
                              <SearchOutlined
                                  onClick={() => {
                                      searchHandler();
                                  }}
                                  className="searchIcon"
                              />
                          </div>
                          <div className="col-1">
                              <Button
                                  onClick={() => {
                                      // console.log("accountData:::::", accountData);
                                      const params = new URLSearchParams();
                                      params.append("osyncId", accountData["Osync ID"]);
                                      params.append("leftServiceId", accountData["Left Service ID"]);
                                      params.append("companyId", accountData["Remote Identifier"].split("_")[1]);
                                      const remoteUserId = userData.find(
                                          (user) => user.email === accountData["Email"]
                                      )?.remoteUserId;
                                      params.append("userId", remoteUserId);
                                      window.open(
                                          ADMIN_SERVER_API + "customer-redirect" + "?" + params.toString(),
                                          "_blank"
                                      );
                                  }}
                              >
                                  <LinkOutlined />
                                  View page
                              </Button>
                          </div>
                      </div>
                      <Divider plain style={{ padding: "0", margin: "0" }} />
                  </div>
              </div>
              {accountData ? (
                  <div className="row w-100 justify-content-center mt-2">
                      <div className="summaryTableWrapper">
                          <Badge.Ribbon
                              text={<Text>{licenseInfoNotifiers ? licenseInfoNotifiers.licensePlanName : ""}</Text>}
                              color={licenseInfoNotifiers ? licenseInfoNotifiers.ribbonColour : "transparent"}
                          >
                              <Card color="#d9d9d9" size="small">
                                  <Descriptions
                                      colon={false}
                                      size="small"
                                      layout="vertical"
                                      items={customerInfoItems}
                                  />
                              </Card>
                          </Badge.Ribbon>
                      </div>
                  </div>
              ) : (
                  <></>
              )}

              {loading ? (
                  <div style={{ background: "rgb(250,250,250,.2)", height: "100vh" }}>
                      <div style={{ position: "absolute", top: "50%", left: "50%" }}>
                          <Spin indicator={antIcon} />
                      </div>
                  </div>
              ) : (
                  <></>
              )}
              <div className="row w-100 justify-content-center customerContainer">
                  <div className="col-11">
                      {accountData ? (
                          <Tabs items={customerTabItems} onChange={handleCurrentTab} activeKey={currentTab} />
                      ) : (
                          <NoData />
                      )}
                  </div>
              </div>
          </Layout>
      </>
  );
}
